import { ExternalToast, toast as sonner } from "sonner";
import { isAxiosError } from "axios";

const toastConfig: ExternalToast = { position: "bottom-right" };

export const showApiError = (error: Error) => {
  if (isAxiosError(error)) {
    if (typeof error.response?.data === "string") {
      const message = error.response?.data;
      if (message.includes("ERR/")) {
        const errorMessage = message.split("ERR/")[1];
        sonner.error(errorMessage, toastConfig);
      } else {
        sonner.error(message, toastConfig);
      }
    } else {
      console.log("logging error to see detailed", error.response?.data);
      sonner.error("An error occurred", toastConfig);
    }
  }
};

export const showSuccess = (message: string) => {
  sonner.success(message, toastConfig);
};
